<template>
  <view class="journey-container">
    <view class="single-city">
      <view
        class="single-city-left"
        wx:class="{{ {'move-r':isExchange, placeholder:!fromCitysName} }}"
        bindtap="goPage('currentFromCity')"
      ><view class="max-ellipsis">{{fromCitysName}}</view></view>
      <view
        class="single-city-right"
        wx:class="{{ {'move-l':isExchange, placeholder:!toCitysName} }}"
        bindtap="goPage('currentToCity')"
      ><view class="max-ellipsis">{{toCitysName}}</view></view>
      <view
        class="change-btn"
        bindtap="exchange"
      >
        <image
          class="change-btn-wrapper"
          wx:class="{{isExchange ? 'rotate' : ''}}"
          mode="widthFix"
          src="{{exchangeWrapperIcon}}"
        />
        <image
          wx:if="{{exchangeIcon}}"
          class="change-btn-icon"
          mode="widthFix"
          src="{{exchangeIcon}}"
        />
      </view>
    </view>
  </view>
</template>

<style lang='stylus' scoped>
@keyframes Rotate
  0%
    transform rotate(0deg)
  100%
    transform rotate(180deg)

.journey-container
  .single-city
    box-sizing border-box
    height 54px
    position relative
    .change-btn
      @extend .expand-click
      position absolute
      left 50%
      top 50%
      transform translateX(-50%) translateY(-50%)
      width 24px
      height 24px
      &-wrapper
        width 100%
        &.rotate
          animation Rotate .3s linear
      &-icon
        width 100%
        position absolute
        left 50%
        top 50%
        transform translateX(-50%) translateY(-50%)
    &-left, &-right
      @extend .flex-center
      position absolute
      height 100%
      white-space nowrap
      color #333
      font-size 20px
      font-weight 500
      font-family 'PingFangSC-Medium'
      &.placeholder
        width 100px
      .max-ellipsis
        max-width 150px
        white-space nowrap
        overflow hidden
        text-overflow ellipsis
        min-width 100px
    &-right
      text-align right 
    .move-l, .move-r
      transition all .3s
    &-left, &-right.move-l
      left 0
      transform translateX(0)
    &-right, &-left.move-r
        left 100%
        transform translateX(-100%)
  .mutiple-city
    box-sizing border-box
    height 114px
    @extend .flex-center
    .list-style
      width 28px
      flex none
      display flex
      flex-direction column
      height 100%
      .point
        height 50%
        width 100%
        @extend .flex-center
        &::after
          content ''
          display block
          width 8px
          height 8px
          border-radius 50%
          background #06B87C
          margin-left 3px
        &:last-child::after
          background #FF6400
    .citys
      flex 1
      height 100%
      overflow hidden
      border-bottom 0.5px solid #EEEEEE
      .placeholder
        width 100%
        height 50%
        box-sizing border-box
        border-bottom 0.5px solid #EEEEEE
        position relative
        .mutiple-city-top, .mutiple-city-bottom
          width 100%
          min-height 20px
          position absolute
          transform translateY(-50%)
          color #333
          font-size 20px
          font-weight 500
          font-family 'PingFangSC-Medium'
          .max-ellipsis
            width 100%
            white-space nowrap
            overflow hidden
            text-overflow ellipsis
            .tip
              font-size 12px
              color #999
              font-family 'PingFangSC'
              font-weight 400
              margin-left 8px
              white-space inherit
        .move-t, .move-b
          transition all .3s
        .mutiple-city-top
          top 50%
          &.move-b
            top 150%
        .mutiple-city-bottom
          top 150%
          &.move-t
            top 50%
    .change-btn
      height 100%
      width 42px
      flex none
      border-bottom 1px solid #EEEEEE
      @extend .flex-center
      justify-content flex-end
      .change-icon
        width 24px
</style>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { setStorage } from '@/utils/storage'
  import { STORAGE_EDIT_CITY_TYPE } from '@/utils/train-storage'
  import { innerRouter, pagePath } from '@/common/jump'
  import { trackEvent, is } from '@didi/webx-js'
  import { debounce } from '@/utils'

  createComponent({
    props: {
      selectCityList: Array
    },
    data: {
      exchangeWrapperIcon: 'https://ut-static.udache.com/webx/sfc/_UzT6gnx4ASMGRvhOywRc.png',
      changeIcon: 'https://ut-static.udache.com/webx/sfc/lTS4DXNy8YBMPAuUmGAcn.png',
      isExchange: false,
      exchangeIcon: "https://ut-static.udache.com/webx/sfc/vKajFJLnHd6i5_WktzSx5.png"
    },
    computed: {
      ...store.mapState({
        token: 'user.token',
        userInfo: 'user.userInfo'
      }),
      isLogin() {
        // 登录后才请求隐私弹窗
        return this.token || this.userInfo?.token
      },
      fromCitysName() {
        return this.selectCityList?.[0]?.name
      },
      toCitysName() {
        return this.selectCityList?.[1]?.name
      },
    },
    methods: {
      /**
       * @description: 跳转到城市选择页面
       * @param {*} type
       */
      goPage(type) {
        // 整改标识
        if (!this.isLogin && !(is('alipay') || is('alimp')) ) {
          this.$trigger('click')
          return
        }
        // if (this.transition) {
        //   return
        // }
        let module
        switch (type) {
          case 'currentFromCity':
            module = 'start_city'
            break

          case 'currentToCity':
            module = 'end_city'
            break
        }
        trackEvent('userteam_train_home_tickets_ck', 'UT-火车票-首页-票模块-点击', { module })
        const url = pagePath().TRAINCITY
        setStorage({ key: STORAGE_EDIT_CITY_TYPE, data: type })
        innerRouter.push(url)
      },
      exchange: debounce(function() {
        trackEvent('userteam_train_home_tickets_ck', 'UT-火车票-首页-票模块-点击', {
          module: 'switch'
        })
        this.isExchange = true
        setTimeout(() => {
          this.$trigger('exchange')
          this.$nextTick(() => {
            this.isExchange = false
          })
        }, 300)
      }, 300, true)
    },
  })
</script>

<script name="json">
  module.exports = {
    component: true
  }
</script>
